/**
 * Cookie Consent Utilities
 * Storage-Keys: snapshot_consent, snapshot_consent_detail
 */

const CONSENT_KEY = 'snapshot_consent';
const CONSENT_DETAIL_KEY = 'snapshot_consent_detail';

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
    window.dispatchEvent(new CustomEvent('consentChanged', { detail: value }));
  } catch (e) {
    console.error('Consent save error:', e);
  }
}

export function getConsentDetail() {
  try {
    const raw = localStorage.getItem(CONSENT_DETAIL_KEY);
    return raw ? JSON.parse(raw) : { statistik: false, marketing: false };
  } catch {
    return { statistik: false, marketing: false };
  }
}

export function setConsentDetail(detail) {
  try {
    localStorage.setItem(CONSENT_DETAIL_KEY, JSON.stringify(detail));
    window.dispatchEvent(new CustomEvent('consentDetailChanged', { detail }));
  } catch (e) {
    console.error('Consent detail save error:', e);
  }
}

export function hasConsent() {
  return !!getConsent();
}

export function acceptAll() {
  setConsent('all');
  setConsentDetail({ statistik: true, marketing: true });
}

export function acceptEssential() {
  setConsent('essential');
  setConsentDetail({ statistik: false, marketing: false });
}